import Vue from 'vue'
import App from './App.vue'
import router from './router.js'
import 'lib-flexible-niuge/flexible'
import infiniteScroll from 'vue-infinite-scroll'
import './assets/css/reset.css'
import './assets/css/common.css'

// import Vant from 'vant';
// import 'vant/lib/index.css';
// Vue.use(Vant)

import {Lazyload} from 'vant'
Vue.use(Lazyload)


// //高德地图
// import VueAMap from 'vue-amap'
// Vue.use(VueAMap);
// VueAMap.initAMapApiLoader({
// //修改下面的key值
//   key: '47ccf9f4475196688fc2dfa142d9d9f9',
//   plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor','AMap.MarkerClusterer'],
//   // 默认高德 sdk 版本为 1.4.4
//   v: '1.4.4'
// })

//高德地图
import VueAMap from 'vue-amap'
VueAMap.initAMapApiLoader({
//修改下面的key值
  key: '47ccf9f4475196688fc2dfa142d9d9f9',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor','AMap.MarkerClusterer','AMap.TruckDriving','AMap.Driving','AMap.Geolocation','AMap.Geocoder','AMap.DistrictSearch'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
});
Vue.use(VueAMap);

let options = {
  fullscreenEl: false, //控制是否显示右上角全屏按钮
  closeEl: false, //控制是否显示右上角关闭按钮
  tapToClose: true, //点击滑动区域应关闭图库
  shareEl: false, //控制是否显示分享按钮
  zoomEl: false, //控制是否显示放大缩小按钮
  counterEl: false, //控制是否显示左上角图片数量按钮
  arrowEl: true,  //控制如图的左右箭头（pc浏览器模拟手机时）
  tapToToggleControls: true, //点击应切换控件的可见性
  clickToCloseNonZoomable: true, //点击图片应关闭图库，仅当图像小于视口的大小时
  showHideOpacity: true, //是否开启动画
  bgOpacity: 0.5 //遮罩层透明度
}

// 无线滚动
Vue.use(infiniteScroll)

Vue.config.productionTip = false



new Vue({
  router,
  render: h => h(App),
}).$mount('#app')

router.afterEach((to) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
})
